import type { ExecutionStatus } from '@/features/decisions/scenarios.api.types';

// Colour carries meaning here, so each status also gets a distinct word rather than
// relying on the swatch alone.
const STYLES: Record<ExecutionStatus, { label: string; className: string }> = {
  not_started: { label: 'Not started', className: 'bg-[#F1F2F5] text-[#5C5F72]' },
  pending: { label: 'Pending', className: 'bg-[#FFF4E0] text-[#8A5A00]' },
  running: { label: 'Running', className: 'bg-[#E7F0FF] text-[#274483]' },
  succeeded: { label: 'Succeeded', className: 'bg-[#E4F5EC] text-[#1B7F53]' },
  failed: { label: 'Failed', className: 'bg-[#FDECEA] text-[#B4291F]' },
};

// Null status means the scenario has never been run, which is not the same as a run that
// has not started yet — so it gets a dash, not a "Not started" badge.
export function StatusBadge({ status }: { status: ExecutionStatus | null }) {
  if (!status) return <span className="text-[14px] text-[#B0B2BD]">—</span>;

  const style = STYLES[status];
  if (!style) return <span className="text-[14px] text-[#5C5F72]">{status}</span>;

  return (
    <span className={`inline-flex rounded-full px-2.5 py-1 text-[12px] font-semibold ${style.className}`}>
      {style.label}
    </span>
  );
}
